import { Component, OnInit } from '@angular/core';
import { AddTaskService } from './add-task.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { DeletePopUpComponent } from '../../../common/delete-pop-up/delete-pop-up.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';
import { UploadHistoryComponent } from '../../../common/upload-history/upload-history.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.css']
})

export class AddTaskComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;

  public taskName = '';
  public taskDescription = '';
  public tasklist: Array<any> = [];
  public submitted = false;
  public addErrors: any;
  public flag = false;
  public userObj;
  constructor(
    public addTaskService: AddTaskService,
    public router: Router,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }

  ngOnInit() {
    this.userObj = {
      'Empno': this.user.Empno,
      'Empname': this.user.Empname,
      'EmailID': this.user.EmailID,
      'Role': this.user.Role,
    };
  }

  /*Function to add activity */
  addTask() {
    this.flag = false;
    this.tasklist.filter((ele, j) => ele.taskName == this.taskName).map(ele => this.flag = true);
    if (!this.flag) {
      this.tasklist.push({ 'taskName': this.taskName, 'taskDescription': this.taskDescription, 'editMode': false });
      this.taskName = '';
      this.taskDescription = '';
      this.submitted = false;
    }
  }

  /* Function to read csv file */
  readCsvFile(event$: any) {
    let file = event$.target.files[0];
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    this.spinnerService.show();
    this.addTaskService.uploadCSV(formData).subscribe(
      (response) => {
        this.spinnerService.hide();
        this.snackBar.open('CSV uploaded successfully', 'OK', {
          duration: 3000,
        });
        this.getTask();
      }, (err) => {
        this.spinnerService.hide();
      });
  }

  /* Function to view upload file history */
  fileUploadHistory() {
    this.spinnerService.show();
    this.addTaskService.uploadHistory().subscribe((response) => {
      this.spinnerService.hide();
      if (this.dialog.openDialogs.length === 0) {
        const dialogRef = this.dialog.open(UploadHistoryComponent, {
          width: '50%',
          data: response.payload
        });
        dialogRef.afterClosed().subscribe(result => {
        });
      }
    }, (err) => {
      this.spinnerService.hide();
    });
  }

  /* Function to go back activity list */
  backToTask() {
    this.router.navigate(['/admin/tasks']);
  }

  /* Function to get activity list */
  getTask() {
    this.addTaskService.getTask().subscribe((response) => {
      this.tasklist = response;
    });
  }

  /* Function to save added activity */
  saveTask() {
    for (let i = 0; i < this.tasklist.length; i++) {
      const data = {
        'activityType': this.tasklist[i].taskName,
        'description': this.tasklist[i].taskDescription,
        'userObj': this.userObj
      };
      this.spinnerService.show();
      this.addTaskService.addTask(data).subscribe((response) => {
        this.spinnerService.hide();
        if (i == this.tasklist.length - 1) {
          if (this.tasklist.length == 1) {
            this.snackBar.open('Activity added successfully', 'OK', {
              duration: 3000,
            });
          } else if (this.tasklist.length > 1) {
            this.snackBar.open('Activity added succcessfully', 'OK', {
              duration: 3000,
            });
          }
          this.router.navigate(['/admin/tasks']);
        }
      },
        (err) => {
          this.spinnerService.hide();
          if (err) {
            this.snackBar.open(err.error.message, 'Okay', {
              duration: 3000,
            });
          }
        });
    }
  }

  /* Function to delete employee */
  deleteEmployee(index) {
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(DeletePopUpComponent);
      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.tasklist.splice(index, 1);
        }
      });
    }
  }

  /* Function to save added activity */
  editEmployee(index) {
    // for (let j = 0; j < this.tasklist.length; j++) {
    //   if (index != j) {
    //     this.tasklist[j].editMode = false;
    //   }
    // }
    this.tasklist.filter((ele, j) => index != j).map(ele => ele.editMode = false);
    this.tasklist[index].editMode = true;
  }

  /* Function to change to edit mode */
  editMode(i, val) {
    this.addErrors = val;
    if (!val.errors) {
      this.tasklist[i].editMode = false;
      this.addErrors = '';
    }
  }

  /* Function to save activity */
  onSubmit(valid) {
    this.submitted = true;
    if (valid) {
      this.addTask();
    }
  }

  /* Function to expand container */
  auto_grow() {
    const activtyName = document.getElementById('description');
    activtyName.style.overflow = 'hidden';
    activtyName.style.height = '0px';
    activtyName.style.height = activtyName.scrollHeight + 'px';
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/tasks/add-task/add-task.component.ts